<template>
  <section :style="{ backgroundImage: `url(${backgroundUrl})` }" class="section-one">
    <div class="content">
      <h5>{{ companyName }}</h5>
      <h1>{{ title }}</h1>
      <h6>{{ description }}</h6>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    colorWord: {
      required: false,
      type: String,
      default: '#fff'
    },
    companyName: {
      required: false,
      type: String,
      default: '禾祺科技'
    },
    title: {
      required: true,
      type: String,
      default: ''
    },
    description: {
      required: true,
      type: String,
      default: '全国各省市诚招合伙人，携手共促档案行业新时代'
    },
    backgroundUrl: {
      required: false,
      type: String,
      default: require('@/assets/images/product_bg.jpg')
    }
  }
}
</script>

<style lang="scss" scoped>
.section-one {
  height: 494px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  color: #fff;
}
.section-one .content {
  color: #fff;
  text-align: center;
  padding: 140px 0 0;
}
.section-one .content h5 {
  margin-bottom: 25px;
  font-size: 30px;
  font-weight: 400;
}
.section-one .content h1 {
  margin-bottom: 25px;
  font-size: 42px;
  font-weight: 500;
}
.section-one .content h6 {
  margin-bottom: 25px;
  font-size: 20px;
  font-weight: 400;
}
@media (max-width: 1200px) {
  .section-one {
    height: 392px;
  }
  .section-one .content {
    padding-top: 100px;
  }
}
@media (max-width: 992px) {
  .section-one .content {
    padding-top: 100px;
  }
  .section-one .content h5 {
    font-size: 26px;
  }
  .section-one .content h1 {
    font-size: 38px;
  }
  .section-one .content h6 {
    font-size: 18px;
  }
}
@media (max-width: 768px) {
  .section-one {
    height: 300px;
  }
  .section-one .content {
    padding-top: 60px;
  }
  .section-one .content h5 {
    font-size: 22px;
  }
  .section-one .content h1 {
    font-size: 32px;
  }
  .section-one .content h6 {
    font-size: 16px;
  }
}
@media (max-width: 442px) {
  .section-one {
    height: 260px;
  }
  .section-one .content {
    padding-top: 80px;
  }
  .section-one .content h5 {
    margin-bottom: 10px;
    font-size: 18px;
  }
  .section-one .content h1 {
    margin-bottom: 10px;
    font-size: 24px;
  }
  .section-one .content h6 {
    font-size: 14px;
  }
}
</style>
